// extracted by mini-css-extract-plugin
module.exports = {"back-to-top-button":"back-to-top_back-to-top-button__2KHdK"};